






import { Component, Vue, Prop } from 'vue-property-decorator'
import { Game, NightAction } from '@/class/game'
import { GamePlayerData } from '@/class/gamePlayer'
import { GameState } from '@/enum'
import Message from './Message.vue'

@Component({
  components: {
    Message
  }
})
export default class Night extends Vue {
  @Prop() game!: Game
  @Prop() nightAction!: NightAction
  @Prop() state!: GameState.firstNight | GameState.night

  get messages () {
    const messages: string[] = []

    if (this.killedPlayers.length === 0) {
      messages.push(`昨夜は平和な夜でした`)
      return messages
    }

    this.killedPlayers.forEach(p => {
      const playerName = this.getName(p)

      messages.push(`${playerName}さんが死体で見つかりました`)
    })

    return messages
  }

  getName(player: GamePlayerData) {
    return `${player.name}`
  }

  get killedPlayers() {
    return this.afterPlayers.filter(p => p.status.killed)
  }

  get afterPlayers() {
    return Object.values(this.afterPlayerOf)
  }

  get afterPlayerOf() {
    return this.nightAction.playLogs.length ? this.nightAction.playLogs[this.nightAction.playLogs.length - 1].afterPlayers : {}
  }
}
